import { render, staticRenderFns } from "./addpro.vue?vue&type=template&id=707421a4&scoped=true&"
import script from "./addpro.vue?vue&type=script&lang=js&"
export * from "./addpro.vue?vue&type=script&lang=js&"
import style0 from "./addpro.vue?vue&type=style&index=0&id=707421a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707421a4",
  null
  
)

export default component.exports